import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { LegacyApiResponse, unwrapLegacyResult } from '../../../shared/utils/legacy-api-response.util';
import { unwrapV2, V2ApiResponse } from '../../../shared/utils/v2-api-response.util';
import { CreditPolicyEntity, CreditPolicyPayload } from '../models/credit-policy-form.model';

@Injectable({ providedIn: 'root' })
export class CreditPolicyCrudService {
  private readonly baseUrl = `${environment.apiUrl}/polizacredito`;
  private readonly v2Url = `${environment.apiUrl}/api/v2/credit-policies`;

  constructor(private http: HttpClient) { }

  get(uid: string): Promise<CreditPolicyEntity> {
    return unwrapV2(
      firstValueFrom(this.http.get<V2ApiResponse<CreditPolicyEntity>>(`${this.v2Url}/${encodeURIComponent(uid)}`)),
      'No se pudo cargar la póliza de crédito'
    );
  }

  create(payload: CreditPolicyPayload): Promise<void> {
    return firstValueFrom(this.http.post<LegacyApiResponse<boolean>>(this.baseUrl, payload))
      .then(response => { unwrapLegacyResult(response, 'Ha ocurrido un error inesperado al añadir la póliza de crédito'); });
  }

  update(uid: string, payload: CreditPolicyPayload): Promise<void> {
    return firstValueFrom(this.http.put<LegacyApiResponse<boolean>>(this.baseUrl, { ...payload, uid }))
      .then(response => { unwrapLegacyResult(response, 'Ha ocurrido un error inesperado al actualizar la póliza de crédito'); });
  }
}
